export const PERMISSIONS = {
  DASHBOARD: {
    MODULE: 'DASHBOARD.READ',
    READ: 'DASHBOARD.READ',
  },
  IMPORT: {
    MODULE: 'IMPORT.SHIPMENTS.READ',
    SHIPMENTS: { READ: 'IMPORT.SHIPMENTS.READ', WRITE: 'IMPORT.SHIPMENTS.WRITE' },
    WORK_ORDERS: { READ: 'IMPORT.WO.READ', WRITE: 'IMPORT.WO.WRITE' },
    RECEIVING: { READ: 'IMPORT.RECEIVING.READ', WRITE: 'IMPORT.RECEIVING.WRITE' },
  },
  EXPENSES: {
    MODULE: 'EXPENSES.READ',
    READ: 'EXPENSES.READ',
    WRITE: 'EXPENSES.WRITE',
    AP: { READ: 'EXPENSES.AP.READ', WRITE: 'EXPENSES.AP.WRITE' },
  },
  SALES: {
    MODULE: 'SALES.SALE_ORDER.READ',
    SALE_ORDER: { READ: 'SALES.SALE_ORDER.READ', WRITE: 'SALES.SALE_ORDER.WRITE' },
    BOL: { READ: 'SALES.BOL.READ', WRITE: 'SALES.BOL.WRITE' },
    SALE_INVOICE: { READ: 'SALES.INV.READ', WRITE: 'SALES.INV.WRITE' },
    INCOME_STMNT: { READ: 'SALES.INCOME.READ' },
    COST_REPORT: { READ: 'SALES.COST.READ' },
  },
  INVENTORY: {
    MODULE: 'INV.ADJ.READ',
    ADJUSTMENT: { READ: 'INV.ADJ.READ', WRITE: 'INV.ADJ.WRITE' },
    REPORT: { READ: 'INV.REPORT.READ', WRITE: 'INV.REPORT.WRITE' },
    MOVEMENT: { READ: 'INV.MOVE.READ', WRITE: 'INV.MOVE.WRITE' },
    COSTING: { READ: 'INV.COST.READ' },
  },
  SETTINGS: {
    MODULE: 'SETTINGS.USER.READ',
    USER_MANAGEMENT: { READ: 'SETTINGS.USER.READ', WRITE: 'SETTINGS.USER.WRITE' },
  },
  REPORTS: {
    MODULE: 'REPORTS.SHIPMENTS.READ',
    SHIPMENTS: {
      READ: 'REPORTS.SHIPMENTS.READ',
      WRITE: 'REPORTS.SHIPMENTS.WRITE',
    },
    AP: {
      READ: 'REPORTS.AP.READ',
      WRITE: 'REPORTS.AP.WRITE',
    },
    AR: {
      READ: 'REPORTS.AR.READ',
      WRITE: 'REPORTS.AR.WRITE',
    },
    INVENTORY: {
      READ: 'REPORTS.INVENTORY.READ',
      WRITE: 'REPORTS.INVENTORY.WRITE',
    },
    INVENTORY_COSTING: {
      READ: 'REPORTS.INVENTORY_COSTING.READ',
      WRITE: 'REPORTS.INVENTORY_COSTING.WRITE',
    },
    GROSS_MARGIN: {
      READ: 'REPORTS.GROSS_MARGIN.READ',
    },
    FINANCIAL_STMNT: {
      READ: 'REPORTS.FINANCIAL_STMNT.READ',
    },
    USERS: {
      READ: 'REPORTS.USERS.READ',
      WRITE: 'REPORTS.USERS.WRITE',
    },
  },
};
